import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as CreDtos from "../CRE.dtos";
import { newsApi } from "../services/news.service";

import {
    NEWS_REQUEST,
    newsRequestSuccess,
    newsRequestFailure,
    newsRequest,
    NEWS_UPSERT_REQUEST,
    newsUpsertRequestFailure,
    newsUpsertRequestSuccess,
    NEWS_UPSERT_REQUEST_SUCCESS,
    NEWS_UPSERT_REQUEST_FAILURE
} from "../actions/news.actions";

import {
    siteDataRequest
} from "../actions/sitedata.actions";

import {
    notificationSuccessShow,
    notificationErrorShow
} from "../actions/notification.actions";

export const newsRequestEpic = action$ =>
    action$
        .ofType(NEWS_REQUEST)
        .mergeMap((action) =>
            newsApi
                .get()
                .mergeMap(response => {
                    return concat$(Observable.of(newsRequestSuccess(response.news)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(newsRequestFailure(error.responseStatus.message))
                )
        );

export const newsUpsertRequestEpic = action$ =>
    action$
        .ofType(NEWS_UPSERT_REQUEST)
        .mergeMap((action) =>
            newsApi
                .upsert(action.news)
                .mergeMap(response => {
                    return concat$(Observable.of(newsUpsertRequestSuccess(response.news)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(newsUpsertRequestFailure(error.responseStatus.message))
                )
        );

export const newsUpsertRequestSuccessEpic = (action$, state$) =>
    action$
        .ofType(NEWS_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => newsRequest());

export const newsUpsertRequestSuccessNotificationEpic = (action$, state$) =>
    action$
        .ofType(NEWS_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => notificationSuccessShow(action.news.title + " saved"));

export const newsUpsertRequestSuccessSiteDataEpic = (action$, state$) =>
        action$
            .ofType(NEWS_UPSERT_REQUEST_SUCCESS)
            .map((action: any) => siteDataRequest());

export const newsUpsertRequestErrorNotificationEpic = (action$, state$) =>
    action$
        .ofType(NEWS_UPSERT_REQUEST_FAILURE)
        .map((action: any) => notificationErrorShow("Save failed: " + action.error));


// WEBPACK FOOTER //
// ./src/epics/news.epic.ts